"use client";

import { useEffect } from "react";

import { ErrorPage } from "~/common/error-page/error-page";

export default function Error({ error }: { error: Error }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return <ErrorPage type="global" />;
}
